// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_users_btn-primary__2cT3a","label":"_users_label__1HTBe","select":"_users_select__3ZfGL"};